import { API_BASE_URL } from "@/config";
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { validateToken } from "@/utils/auth";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";
import Swal from "sweetalert2";

export default {
    name: 'TrustNameSearch',
    mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
    data() {
        return {
            form: {
                trust_name: ''
            }
        };
    },
    components: {
        BreadCrumb,
        ClientLogo
    },
    computed: {
        workflow_id() {
          return this.$store.getters.get_workflow_id;
        }
    },
    methods: {
        submit_trust_name() {
            if (!this.form.trust_name.trim()) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Trust Name is required',
                    timer: 3000,
                    showConfirmButton: false
                });
                return false;
            }
            this.trust_name_search_api();
        },
        trust_name_search_api() {
            const TOKEN = localStorage.getItem('token');
            const TRUST_NAME_SEARCH_API = `${API_BASE_URL}/verify_api/compliance_verification/trust_name_search/`;

            $.ajax({
                url: TRUST_NAME_SEARCH_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    trust_name: this.form.trust_name,
                    workflow_id: this.workflow_id,
                    on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    Swal.fire({
                        icon: 'success',
                        title: 'Successful',
                        text: 'Trust Name Found Successfully',
                        timer: 3000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(() => {
                        this.completeService();
                    });
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error_message,
                        timer: 3000,
                        showConfirmButton: false
                    });
                }
            });
        }
    },
    mounted() {
        if (!validateToken(this.$router)) {
            return;
        }
    }
};
